import { v4 as uuidv4 } from 'uuid'

export class BaseService {

  private id: string

  constructor() {
    this.id = uuidv4()
  }

  getId() {
    // if(!this.id) {
    //   this.id = uuidv4()
    // }
    return this.id
  }
}
